// <SearchIdentity /> — Pass 3 runtime integration.
// Drop-in Helmet head driven entirely by the Search Identity Engine. Any page can
// emit a correct, invariant-compliant search identity with one line:
//
//   <SearchIdentity path="/about-us" />
//
// Pass an explicit `path` (canonical form) for pages reachable under more than one URL
// (e.g. /about and /about-us both render AboutLWD → both should claim /about-us). Omit
// it to use the live route. `cms` and `entity` feed CMS overrides / listing data.
import { Helmet } from 'react-helmet-async';
import { resolveIdentity } from './identityEngine.js';

const SITE_URL = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || undefined;

export default function SearchIdentity({ path, cms, entity }) {
  const p = path || (typeof window !== 'undefined' ? window.location.pathname : '/');
  const id = resolveIdentity(p, { cms, entity, siteUrl: SITE_URL });
  if (!id.title) return null;
  return (
    <Helmet>
      <title>{id.title}</title>
      <meta name="description" content={id.description} />
      <link rel="canonical" href={id.canonical} />
      <meta name="robots" content={id.robots} />
      <meta property="og:title" content={id.ogTitle} />
      <meta property="og:description" content={id.ogDescription} />
      <meta property="og:url" content={id.ogUrl} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={id.ogTitle} />
      <meta name="twitter:description" content={id.ogDescription} />
    </Helmet>
  );
}
